export default {"src":"https://s.sylndr.com/c-0d6ce1e/_next/static/media/profileIconGrey.31c21244.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};